import { AxiosResponse } from 'axios';

import { ApiVersion } from '@/config';
import { IAgency } from '@/models';

import { http } from './http';
import { IGetParams, IListResponse } from './types';

export const AgencyApi = {
  getAgencies: async (): Promise<AxiosResponse<IListResponse<IAgency>>> => {
    return http.get(`api/${ApiVersion.V1}/agencies/`);
  },
  getAgency: async (id: string): Promise<AxiosResponse<IAgency>> => {
    return http.get(`api/${ApiVersion.V1}/agencies/${id}`);
  },
  getPrePlanForm: async (params?: IGetParams): Promise<AxiosResponse> => {
    return http.get(`/api/${ApiVersion.V1}/agencies/get-pre-plan-form`, {
      params,
    });
  },
  updateAgencySettings: async (
    id: string,
    data: Partial<IAgency>,
  ): Promise<AxiosResponse<IAgency>> => {
    return http.patch(`api/${ApiVersion.V1}/agencies/${id}`, data);
  },
};
